import { render, staticRenderFns } from "./zzzxTable.vue?vue&type=template&id=f948dab6&scoped=true"
import script from "./zzzxTable.vue?vue&type=script&lang=js"
export * from "./zzzxTable.vue?vue&type=script&lang=js"
import style0 from "./zzzxTable.vue?vue&type=style&index=0&id=f948dab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f948dab6",
  null
  
)

export default component.exports